import PropTypes from 'prop-types';
import _ from 'underscore';

import type { InstrumentationLogging, Logger } from './logger';

export const loggerPropTypesShape = PropTypes.shape({
  trace: PropTypes.func,
  error: PropTypes.func,
  startScenario: PropTypes.func,
  endScenario: PropTypes.func,
  logPageLoadAndNavigationDuration: PropTypes.func,
});

export const defaultLogger: Logger & InstrumentationLogging = {
  trace: _.noop,
  error: _.noop,
  startScenario: _.noop,
  endScenario: _.noop,
  logPageLoadAndNavigationDuration: _.noop,
};
